import type { ClientOptions, RpcClient } from "@redotech/rpc/client";
import { createRpcClient } from "@redotech/rpc/client";
import {
  rpcDefinition,
  type RedoReturnsProcessingRpcDefinition,
} from "./definition";

export function createRedoReturnsProcessingRpcClient(
  options: ClientOptions<typeof rpcDefinition>,
): RpcClient<RedoReturnsProcessingRpcDefinition> {
  return createRpcClient(rpcDefinition, options);
}

export type RedoReturnsProcessingRpcClient = ReturnType<
  typeof createRedoReturnsProcessingRpcClient
>;
